import React from "react";
import { Alert } from "react-bootstrap";
import IcomoonIcon from "@icons/IcomoonIcon";

interface SntInfoPanelProps {
  className?: string;
  children?: React.ReactNode;
  maxWidth?: number;
  customStyle?: React.CSSProperties;
}

const SntInfoPanel: React.FC<SntInfoPanelProps> = ({
  className,
  children,
  maxWidth = 900,
  customStyle,
}) => {
  return (
    <Alert
      className={className}
      variant="sensolus-grey"
      style={{
        backgroundColor: "#ffffff",
        // border: "1px solid #dee2e6",
        border: "none",
        color: "#304269",
        ...customStyle,
      }}
    >
      <div className="d-flex">
        <div style={{ width: 24 }}>
          <IcomoonIcon className="me-2" icon="info" size={16} />
        </div>
        {/* text longer than 900px is bad for reading. */}
        <div style={{ maxWidth: maxWidth > 0 ? maxWidth : undefined }}>
          {children}
        </div>
      </div>
    </Alert>
  );
};

export default SntInfoPanel;
